<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      lastTime: null, //最后一次点击的时间
      currentTime: null, //当前点击的时间
      timeOut: 10 * 60 * 1000, //设置超时时间： 10分钟
    };
  },
  methods: {
    getPk() {
      this.$apis.manage.getPk().then((res) => {
        sessionStorage.setItem("trip", res.content.pk);
      });
    },
    async getWebIp() {
      const fallbackIp = await this.$apis.manage.getUserIpConfig();
      sessionStorage.setItem("webIp", fallbackIp || "103.43.184.186");
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    isDo() {
      this.currentTime = new Date().getTime(); //记录这次点击的时间
      if (this.currentTime - this.lastTime > this.timeOut) {
        // 这里写状态已过期后执行的操作
        localStorage.removeItem("assessment");
        this.$router.push({ path: "/loginAdmin" });
      } else {
        this.lastTime = new Date().getTime();
      }
    },
  },
  async created() {
    this.lastTime = new Date().getTime(); //网页第一次打开时，记录当前时间
    this.getWebIp();
    this.getPk();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue